import type { ComponentPropsWithRef } from "react";

export const PinSolidIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path
      data-name="Path 246876"
      d="M14.707 2.293a1 1 0 1 0-1.414 1.414l.793.793-5.3 5.3a5.638 5.638 0 0 0-5.444 1.444 2 2 0 0 0 0 2.828l2.586 2.586-3.635 3.635a1 1 0 1 0 1.414 1.414l3.636-3.636 2.586 2.585a2 2 0 0 0 2.828 0 5.638 5.638 0 0 0 1.443-5.443l5.3-5.3.793.793a1 1 0 1 0 1.414-1.414z"
      transform="translate(-2 -2)"
      fill="currentColor"
    />
  </svg>
);
